"use client";

import { NavProvider } from "@/providers/Nav";
export default function Providers({
  children
}) {
  return <NavProvider data-sentry-element="NavProvider" data-sentry-component="Providers" data-sentry-source-file="Providers.tsx">{children}</NavProvider>;
}